import React from "react";
import { Star, Quote } from "lucide-react";

export const ReviewsSection = ({ reviews }) => {
  if (!reviews?.length) return null;
  return (
    <section id="reviews" className="py-20 md:py-32 px-6 md:px-12 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="b2t-overline mb-3">From the Crew</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-navy leading-[1.05] max-w-3xl mx-auto">
            Real reviews.<br />
            <span className="italic font-light text-seafoam-600">Real coastal days.</span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-6">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} className="w-5 h-5 fill-coral text-coral" />
            ))}
            <span className="ml-3 text-sm font-semibold text-navy/70">4.9 / 5 from 1,200+ reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((r) => (
            <article
              key={`${r.name}-${r.title}`}
              data-testid={`review-card-${r.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="relative bg-sand p-7 md:p-8 border border-navy/5 flex flex-col h-full"
            >
              <Quote className="w-7 h-7 text-seafoam-600 mb-4" strokeWidth={1.5} />
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: r.rating }).map((_, idx) => (
                  <Star key={`star-${idx}`} className="w-3.5 h-3.5 fill-coral text-coral" />
                ))}
              </div>
              <h3 className="font-display text-lg font-semibold text-navy mb-2">{r.title}</h3>
              <p className="text-sm text-navy/70 leading-relaxed flex-1">{r.body}</p>
              <div className="mt-6 pt-5 border-t border-navy/10">
                <div className="font-semibold text-sm text-navy">{r.name}</div>
                <div className="text-xs text-navy/50 uppercase tracking-widest mt-0.5">{r.location}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
